import RugbyHeader from '../components/header/rugby-header';

import './rugby-coaches.css';
import { Link } from 'react-router';
import { useEffect, useState } from 'react';
import axios from 'axios';


const srcpath = 'https://familyrugby.com/yt.json'



function RugbyCoaches() {
    const [articles, setArticles] = useState([]);
    useEffect(() => {
        axios
            .get(srcpath)
            .then(response => setArticles(response.data.rugbycoachescard))
            .catch(error => console.error("Ошибка при загрузке JSON:", error));
    }, []);
    return (
        <>
            <RugbyHeader />
            <div className="coaches">
                <div className='coaches__hero'>
                    <div className="container coaches-container">
                        <div className='coaches__hero_title'>OUR COACHES</div>
                        {/* <div className='coaches__hero_subtitle'>About & Players</div> */}
                    </div>
                </div>

                <div className="container coaches-container">
                    <div className='coaches__about'>
                        <div className='coaches__about_title'>About</div>

                        <div className='coaches__about_box'>
                            <div className='coaches__about_img'>
                                <img src='./img/rugby.JPG' alt='RugbyImg' />
                            </div>
                            <div className='coaches__about_descr'>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod doloremque consectetur repellat unde voluptatibus, assumenda omnis quos, quis excepturi quo numquam, eaque consequatur necessitatibus est nisi ullam voluptatum eius esse!
                            </div>
                        </div>

                    </div>


                    <div className='coaches__players'>
                        <div className='coaches__players_title'>Our coaches</div>

                        <div className='coaches__players_box'>

                            {articles.map((article, index) => {
                                return (
                                    <div key={index} className='coaches__players_card'>
                                        <div className='coaches__players_card-img'><img src={article.imgsrc} alt="Coaches Profile"/></div>
                                        <div className='coaches__players_card-title'>{article.name}</div>
                                        <div className='coaches__players_card-descr'>{article.descr}</div>
                                        <Link to={`/${article.playersrc}`} className='coaches__players_card-link'>More</Link>
                                    </div>
                                );
                            })}


                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}


export default RugbyCoaches;